import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { analyticsEnabled, getConsent, initAnalytics, setConsent, track } from "@/lib/analytics";

export const MobileShopBar = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/shop-all")) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 border-t border-neutral-200 bg-white/95 p-3 backdrop-blur md:hidden">
      <Link to="/shop-all" onClick={() => track("shop_now_click", { location: "mobile_bar" })} data-testid="mobile-shop-bar-button" className="btn-lime w-full">
        Shop the live menu
      </Link>
    </div>
  );
};

export const ConsentBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!analyticsEnabled()) return;
    initAnalytics();
    setShow(!getConsent());
  }, []);
  if (!show) return null;
  const choose = (v) => { setConsent(v); setShow(false); };
  return (
    <div role="region" aria-label="Analytics consent" data-testid="consent-bar" className="fixed bottom-20 left-3 right-3 z-40 rounded-2xl border border-neutral-200 bg-white p-4 text-sm text-neutral-600 shadow-2xl sm:left-auto sm:right-6 sm:max-w-sm md:bottom-6">
      <p>We use analytics to improve this site. No data is collected unless you accept.</p>
      <div className="mt-3 flex gap-2">
        <button type="button" className="btn-lime !px-5 !py-2 text-xs" onClick={() => choose("granted")} data-testid="consent-accept-button">Accept</button>
        <button type="button" className="btn-outline !px-5 !py-2 text-xs" onClick={() => choose("denied")} data-testid="consent-decline-button">Decline</button>
      </div>
    </div>
  );
};
